import React from 'react';
import { Select, Skeleton } from 'antd';

import type { SelectProps } from 'antd';
import type { FieldOption } from '@/views/Bera/types';

function filterOption(input: string, option?: FieldOption): boolean {
	const label = option?.label.toLowerCase() ?? '';
	const search = input.toLowerCase();
	const isMatch = label.includes(search);

	return isMatch;
}

export function HierarchySelect({ loading, ...props }: Readonly<SelectProps<string, FieldOption>>): JSX.Element {
	if (loading) {
		return <Skeleton.Input block active size="small" />;
	}

	return <Select showSearch allowClear filterOption={filterOption} {...props} />;
}
